(function() { window.GUID_9ea67501_9f13_47f6_92c7_a67919271fab = { getGuid: function() { return "9ea67501-9f13-47f6-92c7-a67919271fab"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerSearchFilter;
        (function (PlayerSearchFilter) {
            PlayerSearchFilter[PlayerSearchFilter["Name"] = 0] = "Name";
            PlayerSearchFilter[PlayerSearchFilter["Event"] = 1] = "Event";
            PlayerSearchFilter[PlayerSearchFilter["Association"] = 2] = "Association";
            PlayerSearchFilter[PlayerSearchFilter["Operator"] = 3] = "Operator";
            PlayerSearchFilter[PlayerSearchFilter["Location"] = 4] = "Location";
            PlayerSearchFilter[PlayerSearchFilter["HomeBar"] = 5] = "HomeBar";
            PlayerSearchFilter[PlayerSearchFilter["CSR"] = 6] = "CSR";
        })(PlayerSearchFilter = Enumeration.PlayerSearchFilter || (Enumeration.PlayerSearchFilter = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerSearchFilter.pre.js.map
